import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ProfileHttp } from '../../../tsScripts/providers/http/ProfileHttp';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
import { AgentDetailDTO } from '../../../tsScripts/DTO/AgentDetailDTO';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'modal-edit-profile',
    templateUrl: "../../../views/components/myProfile/modalEditUserProfile.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class ModalEditUserProfile implements OnInit {

    agent: AgentDetailDTO;
    loading: boolean;
    loadingEdit: boolean;
    email = new FormControl('', [Validators.required, Validators.email]);
    error: boolean;
    errorMessage: string;
    showValidation: boolean;

    @Input()
    agentId: string;

    constructor(private ProfileHttp: ProfileHttp,
                private activeModal: NgbActiveModal) {
        this.loading = false;
        this.loadingEdit = false;
        this.error = false;
        this.showValidation = false;
    }

    cancel() {
        this.activeModal.close();
    }

    private getUser() {
        this.loading = true;
        this.error = false;
        this.ProfileHttp.getLoggedUserData({}).then((response: AgentDetailDTO) => {
            this.loading = false;
            this.agent = response;
            this.email.setValue(response.email);
        }, (error: ErrorDTO) => {
            this.error = true;
            this.loading = false;
            this.errorMessage = error.errorMessage;
        });
    }

    edit() {
        this.loadingEdit = true;
        this.showValidation = false;
        this.agent.email = this.email.value;
        let validUserName = (this.agent.username && this.agent.username !== '') ? true : false;
        let validUserEmail = (this.agent.email && this.agent.email !== '' && this.email.valid) ? true : false;

        if (validUserName && validUserEmail) {
            this.ProfileHttp.editProfileData(this.agent).then((response: any) => {
                this.loadingEdit = false;
                MessageStorage.add("success", "Usuario editado con éxito");
                this.activeModal.dismiss();
            }, (error: ErrorDTO) => {
                this.loadingEdit = false;
                this.error = true;
                this.errorMessage = error.errorMessage;
            });
        } else {
            this.error = false;
            this.loadingEdit = false;
            this.showValidation = true;
        }
    }

    ngOnInit() {
        this.getUser();
    }
}